<template>
            <v-card  :loading="presenceEditLoadStatus===1 || presenceEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>
                             <v-col cols="12" sm="4" md="4">
                              <v-switch @change="presentChange" v-model="editedItem.present" :label="editedItem.present?'Obecne':'Nieobecne'"></v-switch>
                            </v-col>   
                                         
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                      
                                ref="menuEntry"
                                v-model="menuEntry"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.entry"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   :disabled="!editedItem.present"
                                   v-model="editedItem.entry" 
                                   label="Wejście"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuEntry"
                                  v-model="editedItem.entry"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuEntry.save(editedItem.entry)"
                                ></v-time-picker>
                              </v-menu>                           
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                ref="menuLeave"
                                v-model="menuLeave"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.leave"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   :disabled="!editedItem.present"
                                   v-model="editedItem.leave" 
                                   label="Wyście"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                   clearable
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuLeave"
                                  v-model="editedItem.leave"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuLeave.save(editedItem.leave)"
                                ></v-time-picker>
                              </v-menu>                           
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="!childItem.rate || childItem.rate.hasBreakfast">
                              <v-checkbox  :disabled="!editedItem.present" v-model="editedItem.breakfast" label="Śniadanie"></v-checkbox>
                            </v-col>   
                            <v-col cols="12" sm="3" md="3" v-if="!childItem.rate || childItem.rate.hasLunch">
                              <v-checkbox  :disabled="!editedItem.present" v-model="editedItem.lunch" label="Obiad"></v-checkbox>
                            </v-col>   
                            <v-col cols="12" sm="3" md="3" v-if="!childItem.rate || childItem.rate.hasTea">
                              <v-checkbox  :disabled="!editedItem.present" v-model="editedItem.tea" label="Podwieczorek"></v-checkbox>
                            </v-col>     
                           <v-col cols="6" sm="6" md="6">
                              <v-text-field hide-details="auto" v-model="editedItem.note" label="Uwagi"></v-text-field>
                            </v-col> 
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-if="editedItem.picking_up" clearable hide-details="auto" v-model="editedItem.picking_up" label="Odebrane przez"></v-text-field>
                              <v-select
                                v-else
                                v-model="editedItem.picking_up"
                                 :error-messages="picking_upErrors"  
                                  @input="$v.editedItem.picking_up.$touch()"  
                                  @blur="$v.editedItem.picking_up.$touch()"
                                :items="childItem.owners"
                                item-text="desc_with_role"
                                item-value="desc_with_role"
                                label="Odebrane przez"
                                :hint="childItem.pickup?'Wskazanie osoby przy wyjściu jest wymagane':''"
                                persistent-hint
                              ></v-select>
                            </v-col>  
                            <v-col v-if="editedItem.present && !editedItem.presentOrig && editedItem.note && itemEditing" cols="12" sm="12" md="12">
                              <v-checkbox hide-details="auto" v-model="editedItem.deleteNext" label="Usuń wszystkie przyszłe nieobecności"></v-checkbox>
                            </v-col>  
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>      
</template>

<script>
  import requiredIf from 'vuelidate/lib/validators/requiredIf'

  export default {
    data: () => ({
        menuEntry: false,
        menuLeave: false,
    }),
    props:['itemEditing'],
    validations() {
      return{
        editedItem:{
          picking_up:{
            requiredIf: requiredIf(() => { 
              return this.childItem.pickup && this.editedItem.leave;
            })
          }
        }
      }
    },
    watch: {
        settlementAddStatus(val){
            if(val==2){
                this.close();
            }
        }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      
      },
      picking_upErrors () {
        const errors = []
        if (!this.$v.editedItem.picking_up.$dirty) return errors
        !this.$v.editedItem.picking_up.requiredIf && errors.push('Wskazanie osoby przy wyjściu jest wymagane')
        return errors
      },
      editedItem(){
        return this.$store.getters.getPresenceEdit.presences;
      },
      childItem(){
        return this.$store.getters.getPresenceEdit;
      },
      presenceEditLoadStatus(){
        return this.$store.getters.getPresenceEditLoadStatus;
      },
      presenceEditStatus(){
        return this.$store.getters.getPresenceEditStatus();
      },
      presenceEditText(){
        return this.$store.getters.getPresenceEditText
      },
      presenceAddStatus(){
        return this.$store.getters.getPresenceAddStatus();
      },
      presenceAddText(){
        return this.$store.getters.getPresenceAddText;
      },
      formTitle () {
        return !this.itemEditing ? 'Nowy wpis dziennika' : 'Edycja wpisu dziennika'
      },
    },
 
    methods: {
      close(){
        this.$v.$reset();
        this.$emit('close');
      },
      presentChange(val){
        if(val){
          this.editedItem.breakfast = true;
          this.editedItem.lunch = true;
          this.editedItem.tea = true;
        }else{
          this.editedItem.breakfast = false;
          this.editedItem.lunch = false;
          this.editedItem.tea = false;
          this.editedItem.entry = '';
          this.editedItem.leave = '';
          this.editedItem.picking_up = '';
        }
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editPresenceV2', {
                slug: this.editedItem.id,
                child_id:this.editedItem.child_id,
                day:  this.editedItem.day,
                entry: this.editedItem.entry,
                leave: this.editedItem.leave,
                present: this.editedItem.present,
                breakfast: (!this.childItem.rate || this.childItem.rate.hasBreakfast)?this.editedItem.breakfast:false,
                lunch: (!this.childItem.rate || this.childItem.rate.hasLunch)?this.editedItem.lunch:false,
                tea: (!this.childItem.rate || this.childItem.rate.hasTea)?this.editedItem.tea:false,
                note: this.editedItem.note,
                deleteNext:this.editedItem.deleteNext,
                picking_up:this.editedItem.picking_up
              });
            } else {//new item
              this.$store.dispatch( 'addPresenceV2', {
                child_id:this.editedItem.child_id,
                day:  this.editedItem.day,
                entry: this.editedItem.entry,
                leave: this.editedItem.leave,
                present: this.editedItem.present,
                breakfast: (!this.childItem.rate || this.childItem.rate.hasBreakfast)?this.editedItem.breakfast:false,
                lunch: (!this.childItem.rate || this.childItem.rate.hasLunch)?this.editedItem.lunch:false,
                tea: (!this.childItem.rate || this.childItem.rate.hasTea)?this.editedItem.tea:false,
                note: this.editedItem.note,
                picking_up:this.editedItem.picking_up
              });

            }
        }
      },
    },
  }
</script>

